import React from 'react';

export const FormInfoUser = ({id, role, label, ariaLabel, children}) => {
  return (
    <div className="form-group" role={role} aria-labelledby={ariaLabel}>
      {label && (<label id={id} htmlFor={id} className="form-label">{label}</label>)}
      {children}
    </div>
  );
};